import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.replace.js";
import { getObjectName } from '@/utils';

// set function parseTime,formatTime to filter
export { parseTime, formatTime, formatTime2, addDate, formatDecimal, formatNumber } from '@/utils';
function pluralize(time, label) {
  if (time === 1) {
    return time + label;
  }
  return time + label + 's';
}
export function timeAgo(time) {
  var between = Date.now() / 1000 - Number(time);
  if (between < 3600) {
    return pluralize(~~(between / 60), ' minute');
  } else if (between < 86400) {
    return pluralize(~~(between / 3600), ' hour');
  } else {
    return pluralize(~~(between / 86400), ' day');
  }
}

/* 数字 格式化*/
export function numberFormatter(num, digits) {
  var si = [{
    value: 1e18,
    symbol: 'E'
  }, {
    value: 1e15,
    symbol: 'P'
  }, {
    value: 1e12,
    symbol: 'T'
  }, {
    value: 1e9,
    symbol: 'G'
  }, {
    value: 1e6,
    symbol: 'M'
  }, {
    value: 1e3,
    symbol: 'k'
  }];
  for (var i = 0; i < si.length; i++) {
    if (num >= si[i].value) {
      return (num / si[i].value + 0.1).toFixed(digits).replace(/\.0+$|(\.[0-9]*[1-9])0+$/, '$1') + si[i].symbol;
    }
  }
  return num.toString();
}
export function toThousandslsFilter(num) {
  return (+num || 0).toString().replace(/^-?\d+/g, function (m) {
    return m.replace(/(?=(?!\b)(\d{3})+$)/g, ',');
  });
}

/**
 * 上传图片地址
 */
export var imageUrl = function imageUrl(url) {
  if (url.indexOf('http://') || url.indexOf('https://')) {
    return url;
  }
  return '/uploads/' + url;
};
export var filterTagState = function filterTagState(state) {
  var stateMap = {
    1: 'success',
    0: 'danger',
    null: 'info'
  };
  return stateMap[state];
};

/**
 * 学籍状态
 * @param {*} state
 */
export var filterStudentStatus = function filterStudentStatus(state) {
  var stateMap = {
    0: '报名',
    1: '正式学籍',
    2: '暂缓注册',
    3: '保留学籍',
    4: '休学',
    5: '已离校',
    6: '退学',
    7: '流失',
    9: '结业',
    10: '自主择业',
    99: '删除'
  };
  return stateMap[state];
};

/**
 * 性别filter
 * @param {*} state
 */
export var filterGender = function filterGender(state) {
  var stateMap = {
    1: '男',
    2: '女'
  };
  return stateMap[state];
};

/**
 * 支付方式
 * @param {*} state
 */
export var filterPayType = function filterPayType(state) {
  var stateMap = {
    0: '现金',
    1: '银行卡',
    2: '支付宝',
    3: '微信'
  };
  return stateMap[state];
};

/**
 * 身份证类型
 * @param {*} state
 * @returns
 */
export var filterIdType = function filterIdType(state) {
  var stateMap = {
    1: '居民身份证（户口簿）',
    2: '香港特区护照/港澳居民来往内地通行证',
    3: '澳门特区护照/港澳居民来往内地通行证',
    4: '台湾居民来往大陆通行证',
    5: '外国人护照',
    6: '社会保障卡'
  };
  return stateMap[state];
};

/**
 * 字典MAP
 * @param {*} state
 */
export var filterDict = function filterDict(state) {
  var stateMap = {
    1: '联系电话',
    11: '性别',
    12: '教育程度',
    13: '专业',
    14: '费用类型',
    15: '民族',
    16: '异动类型',
    17: '政治面貌',
    18: '户口性质',
    19: '学制',
    21: '问卷'
  };
  return stateMap[state];
};
export var filterState = function filterState(state) {
  var stateMap = {
    1: '正常',
    0: '停用'
  };
  return stateMap[state];
};
export var filterStateTag = function filterStateTag(state) {
  var stateMap = {
    1: 'primary',
    0: 'danger'
  };
  return stateMap[state];
};
export var enableValFilter = function enableValFilter(state) {
  var stateMap = {
    1: '激活',
    0: '停用'
  };
  return stateMap[state];
};
export var visibleValFilter = function visibleValFilter(state) {
  var stateMap = {
    1: '显示',
    0: '隐藏'
  };
  return stateMap[state];
};
export var auditValFilter = function auditValFilter(state) {
  var stateMap = {
    1: '通过',
    0: '未通过',
    null: '未审核'
  };
  return stateMap[state];
};

/**
 * 星期
 * @param {*} state
 */
export var weekdayFilter = function weekdayFilter(state) {
  var weekdayMap = {
    1: '星期一',
    2: '星期二',
    3: '星期三',
    4: '星期四',
    5: '星期五',
    6: '星期六',
    7: '星期日'
  };
  return weekdayMap[state];
};

/**
 * 星期
 * @param {*} state
 */
export var weekdaysFilter = function weekdaysFilter(state) {
  var weekdayMap = {
    1: '周一',
    2: '周二',
    3: '周三',
    4: '周四',
    5: '周五',
    6: '周六',
    7: '周日'
  };
  return weekdayMap[state];
};

/**
 * 星期
 * @param {*} state
 */
export var weekdateFilter = function weekdateFilter(state) {
  var map = {
    0: '周日',
    1: '周一',
    2: '周二',
    3: '周三',
    4: '周四',
    5: '周五',
    6: '周六'
  };
  var date = new Date(state);
  return map[date.getDay()];
};

/**
 * 上午/下午
 * @param {*} state
 */
export var ampmFilter = function ampmFilter(state) {
  var weekdayMap = {
    1: '上午',
    2: '上午',
    3: '下午',
    4: '下午',
    5: '晚上'
  };
  return weekdayMap[state];
};

/**
 * 上午/下午
 * @param {*} state
 */
export var timeSlotFilter = function timeSlotFilter(state) {
  var map = {
    0: '08:50-10:10',
    1: '10:20-11:40',
    2: '14:30-15:40',
    3: '15:50-17:00',
    4: '19:00-21:00'
  };
  return map[state];
};

/**
 * 请假类型
 * @param {*} state
 * @returns
 */
export var askleaveFilter = function askleaveFilter(state) {
  var map = {
    1: '事假',
    2: '病假',
    5: '婚假',
    6: '丧假',
    7: '产假',
    8: '年休假',
    9: '公假'
  };
  return map[state];
};

/**
 * 流程状态
 * @param {*} state
 * @returns
 */
export var workflowFilter = function workflowFilter(state) {
  var map = {
    0: '未启动',
    1: '进行中',
    2: '已完成',
    3: '已取消',
    4: '暂停',
    5: '失败',
    6: '拒绝'
  };
  return map[state];
};

/**
 * 流程状态
 * @param {*} state
 * @returns
 */
export var workflowColorFilter = function workflowColorFilter(state) {
  var map = {
    0: 'warning',
    1: 'primary',
    2: 'success',
    3: 'info',
    4: 'danger',
    5: 'danger',
    6: 'danger'
  };
  return map[state];
};

/**
 * 流程状态
 * @param {*} state
 * @returns
 */
export var workflowTaskFilter = function workflowTaskFilter(state) {
  var map = {
    0: '未处理',
    1: '通过',
    2: '拒绝',
    3: '转办',
    4: '跳过',
    5: '暂停',
    6: '失败',
    7: '退回',
    8: '加签',
    9: '抄送'
  };
  return map[state];
};

/**
 * 流程状态
 * @param {*} state
 * @returns
 */
export var workflowTaskColorFilter = function workflowTaskColorFilter(state) {
  var map = {
    0: 'warning',
    1: 'success',
    2: 'danger',
    3: 'success',
    4: 'danger',
    5: 'danger',
    6: 'danger',
    7: 'warning',
    8: 'primary',
    9: 'primary'
  };
  return map[state];
};

/**
 * 系统name值
 *
 * @param {*} state
 */
export var nameFilter = function nameFilter(state) {
  var result = '';
  if (state != null) {
    result = state.name;
  }
  return result;
};

/**
 * 处理字典模型的对象
 *
 * @param {*} state
 */
export var filterObject = function filterObject(state, name) {
  var result = '';
  if (name.indexOf('.') !== -1) {
    var keys = name.split('.');
    if (state[keys[0]] === undefined) {
      result = '';
      return;
    }
    var val = state[keys[0]][keys[1]];
    if (val instanceof Object) {
      result = val['name'];
    } else {
      result = val;
    }
  } else {
    if (state[name] !== undefined) {
      result = getObjectName(state[name]);
    }
  }
  return result;
};

/**
 * 模糊处理
 * @param {*} str
 * @param {*} start
 * @param {*} end
 */
export var filterObscure = function filterObscure(str, start, end) {
  var len = str.length - start - end;
  var c = '';
  for (var i = 0; i < len; i++) {
    c += '*';
  }
  return str.substring(0, start) + c + str.substring(str.length - end);
};